<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom et Modèle du produit</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon2">Catégorie</span>
      </div>
      <input type="text" class="form-control" placeholder="Adresse email" aria-label="Email" aria-describedby="basic-addon2">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de création</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
      <input type="text" aria-label="Last name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de mise à jour</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Prix</span>
      </div>
      <input type="number" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Description</span>
      </div>
      <textarea aria-label="First name" class="form-control"></textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="ville">Monnaie</label>
      </div>
      <select class="custom-select" id="ville">
        <option>Choose...</option>
        <option selected value="1">Kinshasa</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Code du produit</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Réduction</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="etat_produit">Etat du produit</label>
      </div>
      <select class="custom-select" id="etat_produit">
        <option>Choose...</option>
        <option selected value="1">Kinshasa</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Quantité disponible</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Vendeur</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Adresse</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm mb-3 d-flex flex-row">
      <p class="font-weight-bold text-nowrap">Note : </p>
      <p class="align-self-center ml-3">
        Ce compte a été supprimé parce que l'utilisateur ne respectais pas les règles de la cmpagnie
      </p>
    </div>
  </form>
</template>

<script>
export default {
  name: "create"
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/produits_disponible/components/Create.vue